import { Base } from 'src/.generated/Foundation.GMI.model';
import { usePlainTextWrapper } from 'components/helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { useRichTextWrapper } from 'components/helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { CtaComponentClass } from 'lib/hooks/theming/useCtaComponentClass';
import { PreambleProps } from './Preamble';
import { useImageWrapper } from 'components/helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import { useCtaFields } from 'components/helpers/Atoms/Cta/Cta.sitecore';

interface PreambleSitecoreProps {
  fields: Base.ComponentFields.BasePreamble['fields'];
  ctaComponentClassOverrides?: {
    cta1: CtaComponentClass;
    cta2: CtaComponentClass;
  };
}

export function usePreambleFields({
  fields,
  ctaComponentClassOverrides,
}: PreambleSitecoreProps): PreambleProps {
  const headline = usePlainTextWrapper({ field: fields?.headline });
  const headlineIcon = useImageWrapper({ field: fields?.headlineIcon });
  const headlineEyebrow = usePlainTextWrapper({ field: fields?.headlineEyebrow });
  const headlineSubhead = usePlainTextWrapper({ field: fields?.headlineSubhead });
  const headlineDescription = useRichTextWrapper({ field: fields?.headlineDescription });

  const { cta1, cta2 } = useCtaFields({
    fields,
    ctaComponentClassOverrides,
    contentResultAnalytics: {
      contentListName:
        fields?.headline?.value?.trim() || fields?.headlineSubhead?.value?.trim() || undefined,
    },
  });

  return {
    headline,
    headlineIcon,
    headlineEyebrow,
    headlineSubhead,
    headlineDescription,
    cta1,
    cta2,
  };
}
